<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Custom Fields</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="50"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="ordering"
            direction="ASC"
            delete-label="label"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Sections",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'custom-fields',
                numberOfFilters: 1,
                pageActions: {
                    buttons: [
                        {
                            label: 'New Custom Field',
                            icon: 'plus',
                            type: 'router-link',
                            link: '/configuration/custom-fields/create',
                            iconClass: 'text-green-600'
                        },
                        {
                            label: 'Re-Order',
                            icon: 'sort',
                            type: 'router-link',
                            link: '/configuration/custom-fields/order',
                            iconClass: 'text-gray-800'
                        }
                    ],
                    additional: []
                },
                fields: [
                    {
                        name: 'Label',
                        column: 'label',
                        route: '/configuration/custom-fields/{id}/edit',
                        linked: true,
                        sortCol: 'label'
                    },
                    {
                        name: 'Section',
                        column: 'model',
                    },
                    {
                        name: 'Type',
                        column: 'type_display',
                    },
                    {
                        name: 'Width',
                        column: 'width_display',
                        align: 'center'
                    },
                    {
                        name: 'Ordering',
                        column: 'ordering',
                        align: 'center'
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: this.resource+'.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: this.resource+'.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);
        }
    }
</script>

<style scoped>

</style>
